import script from "./BoardingControlCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardingControlCenter.vue?vue&type=script&setup=true&lang=js"

import "./BoardingControlCenter.vue?vue&type=style&index=0&id=d1746eea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1746eea"]])

export default __exports__